/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React, {useState} from "react";
import "../Authentication.css";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';


// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Row,
    Col,
    Spinner
} from "reactstrap";
import {login} from "../../../../network/ApiAxios";
import {useNavigate, useLocation } from "react-router-dom";
import  secureLocalStorage  from  "react-secure-storage";
import eyeIcon from "assets/img/icons/common/eye-button.svg";
import eyeSlashIcon from "assets/img/icons/common/eye-off-icon.svg";

const Login = props => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { origin } = location.state || {}; // Destructure with a fallback for safety
    const [showPassword, setShowPassword] = useState(false);

    const tryLogin = async () => {
        setIsLoading(true); 
        setError(""); 
        
        try {
            const response = await login(email, password);
            const {data} = response;
            
            if (data.success) {
                setError("");
                secureLocalStorage.setItem("token", data.token);
                secureLocalStorage.setItem("user", JSON.stringify(data.user));
                if(!origin)
                    navigate("/admin");
                else
                    navigate(origin);
            } else {
                setPassword("");
                setError(data.msg);
            }
        } catch (error) {
            setError("Erro de conexão. Tente novamente.");
        } finally {
            setIsLoading(false); // Para loading independente do resultado
        }
    }


    const handleLoginSubmit = (e) => {
        e.preventDefault(); 

        if(!isLoading){
            tryLogin();
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    }

    return (
        <>
            
                <Col className="mb-4 d-none d-lg-block" lg="7" md="6">
                    <DotLottieReact
                        src="https://lottie.host/3364ca8c-7039-464a-8d48-8e6dbbc6d492/vwjhHYfVpU.lottie"
                        loop
                        autoplay
                    />
                </Col>

                <Col className="mb-4 mr-0" lg="5" md="6">
                    <Card className="bg-white shadow border-0 mt-5 mt-sm-3 pt-sm-2 pt-md-0">
                        <CardHeader className="bg-transparent pb-2 border-0">
                            <h1 className="text-black text-center">Welcome back!</h1>
                    
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-3 pb-0">
                        
                            <Form role="form" onSubmit={handleLoginSubmit}>
                                <FormGroup className="mb-3">
                                    <InputGroup className="input-group-alternative">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="ni ni-email-83"/>
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input placeholder="Enter your email adress" type="email" autoComplete="email" value={email}
                                            onChange={e => setEmail(e.target.value)} disabled={isLoading}/>
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <InputGroup className="input-group-alternative">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="ni ni-lock-circle-open"/>
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input placeholder="Enter your password" type={showPassword ? "text" : "password"} autoComplete="password" value={password}
                                            onChange={e => setPassword(e.target.value)} disabled={isLoading}/>
                                            
                                            <Button className="password-btn" onClick={togglePasswordVisibility}>
                                                <img
                                                    id="password-btn-icon"
                                                    alt={showPassword ? "Hide password" : "Show password"}
                                                    src={showPassword ? eyeIcon : eyeSlashIcon}
                                                />
                                            </Button>

                                    </InputGroup>
                                </FormGroup>
                                {/*<div className="custom-control custom-control-alternative custom-checkbox">*/}
                                {/*    <input*/}
                                {/*        className="custom-control-input"*/}
                                {/*        id=" customCheckLogin"*/}
                                {/*        type="checkbox"*/}
                                {/*    />*/}
                                {/*    <label*/}
                                {/*        className="custom-control-label"*/}
                                {/*        htmlFor=" customCheckLogin"*/}
                                {/*    >*/}
                                {/*        <span className="text-muted">Remember me</span>*/}
                                {/*    </label>*/}
                                {/*</div>*/}
                                {error ?
                                    <div className="text-muted font-italic">
                                        <small>
                                            error:{" "}
                                            <span className="text-red font-weight-700">{error}</span>
                                        </small>
                                    </div> : null }
                                <div className="text-center">
                                    <Button className="btn-signin btn-block my-2" type="submit" disabled={isLoading}>
                                        {isLoading ? (
                                            <>
                                                <Spinner size="sm" className="me-2 mx-1" />
                                                Signing in...
                                            </>
                                        ) : (
                                            "Sign In"
                                        )}

                                    </Button>
                                </div>
                            </Form>
                        <Row className="xs-2 mt-1 justify-content-between">
                            <Col xs="auto">
                                <a
                                    className="text-light"
                                    style={{cursor: 'pointer'}}
                                    onClick={() =>  navigate('/auth/reset-password')}
                                >
                                    <small>Forgot password?</small>
                                </a>
                            </Col>

                            <Col xs="auto">
                                <a
                                    className="text-light text-left"
                                    style={{cursor: 'pointer'}}
                                    onClick={() => navigate('/auth/register', { state: { origin: origin}})}
                                >
                                    <small>Don't have an account? Sign up</small>
                                </a>
                            </Col>
                            
                        </Row>
                        

                        {/* <div className="text-muted text-center mt-3 mb-3">
                            <small>Or sign in with</small>
                        </div>
                        <div className="btn-wrapper text-center">
                            <Button
                                className="btn-neutral btn-icon"
                                color="default"
                                href="#pablo"
                                onClick={e => e.preventDefault()}
                            >
                                <span className="btn-inner--icon">
                                    <img
                                        alt="..."
                                        src={require("assets/img/icons/common/google.svg").default}
                                    />
                                </span>
                                <span className="btn-inner--text">Google</span>
                            </Button>
                        </div> */}

                    </CardBody>
                        
                        

                    </Card>
                    
                </Col>

        </>
    );
}

export default Login;
